interface Price {
  amount: number;
  price_id?: null | string;
}

export interface Tier {
  name: string;
  type: 'congress' | 'exhibition';
  prices: NodeJS.Dict<Price>;
  product_id?: string;
  discount?: string;
}

export const discountFactor = 0.5;

export const fullPrices = {
  basic: {
    congress: {
      usd: 0,
      eur: 0,
      cny: 0,
    },
    exhibition: {
      usd: 0,
      eur: 0,
      cny: 0,
    },
  },
  gold: {
    congress: {
      usd: 3000,
      eur: 2500,
      cny: 20000,
    },
    exhibition: {
      usd: 6000,
      eur: 5000,
      cny: 40000,
    },
  },
  platinum: {
    congress: {
      usd: 4000,
      eur: 3500,
      cny: 27000,
    },
    exhibition: {
      usd: 8000,
      eur: 7000,
      cny: 54000,
    },
  },
} as any;

export const tiers: NodeJS.Dict<Tier[]> = {
  production: [
    {
      name: 'basic',
      type: 'congress',
      prices: {
        usd: {
          amount: 0,
          price_id: null,
        },
        eur: {
          amount: 0,
          price_id: null,
        },
        cny: {
          amount: 0,
          price_id: null,
        },
      },
    },
    {
      name: 'basic',
      type: 'exhibition',
      prices: {
        usd: {
          amount: 0,
          price_id: null,
        },
        eur: {
          amount: 0,
          price_id: null,
        },
        cny: {
          amount: 0,
          price_id: null,
        },
      },
    },
    {
      name: 'gold',
      type: 'congress',
      product_id: 'prod_LEYuGfiIu8Mzug',
      prices: {
        usd: {
          amount: fullPrices.gold.congress.usd,
          price_id: 'price_1KY5mUDHPIqaOssu4dmeuYvm',
        },
        eur: {
          amount: fullPrices.gold.congress.eur,
          price_id: 'price_1KY5mUDHPIqaOssuBv4Bt93u',
        },
        cny: {
          amount: fullPrices.gold.congress.cny,
          price_id: 'price_1KnIGODHPIqaOssu1mExsoaO',
        },
      },
    },
    {
      name: 'gold',
      type: 'exhibition',
      product_id: 'prod_LEYu0CFOc7vITQ',
      prices: {
        usd: {
          amount: fullPrices.gold.exhibition.usd,
          price_id: 'price_1KY5n9DHPIqaOssutUQ2yVqE',
        },
        eur: {
          amount: fullPrices.gold.exhibition.eur,
          price_id: 'price_1KY5n9DHPIqaOssup9P2m9oj',
        },
        cny: {
          amount: fullPrices.gold.exhibition.cny,
          price_id: 'price_1KnIFzDHPIqaOssulW2ap3J4',
        },
      },
    },
    /**
     * Using Gold Package prices for platinum until end of august 2022
     */
    {
      name: 'platinum',
      type: 'congress',
      product_id: 'prod_LEYvkSq1Ua2Lwk',
      discount: '40% off until Dec 31',
      prices: {
        usd: {
          amount: fullPrices.gold.congress.usd,
          price_id: 'price_1LIYjmDHPIqaOssusGgqVAK4',
        },
        eur: {
          amount: fullPrices.gold.congress.eur,
          price_id: 'price_1LIYjmDHPIqaOssu2E30Vrfn',
        },
        cny: {
          amount: fullPrices.gold.congress.cny,
          price_id: 'price_1LIYjmDHPIqaOssutUzAkCEK',
        },
      },
    },
    {
      name: 'platinum',
      type: 'exhibition',
      product_id: 'prod_LEYwsXYzkoCSy9',
      discount: '40% off until Dec 31',
      prices: {
        usd: {
          amount: fullPrices.gold.exhibition.usd,
          price_id: 'price_1LIYiQDHPIqaOssuuEsN3eyF',
        },
        eur: {
          amount: fullPrices.gold.exhibition.eur,
          price_id: 'price_1LIYiQDHPIqaOssuBQATNtnp',
        },
        cny: {
          amount: fullPrices.gold.exhibition.cny,
          price_id: 'price_1KnIH5DHPIqaOssu5zDdwpvM',
        },
      },
    },
  ],
  development: [
    {
      name: 'basic',
      type: 'congress',
      prices: {
        usd: {
          amount: 0,
          price_id: null,
        },
        eur: {
          amount: 0,
          price_id: null,
        },
        cny: {
          amount: 0,
          price_id: null,
        },
      },
    },
    {
      name: 'basic',
      type: 'exhibition',
      prices: {
        usd: {
          amount: 0,
          price_id: null,
        },
        eur: {
          amount: 0,
          price_id: null,
        },
        cny: {
          amount: 0,
          price_id: null,
        },
      },
    },
    {
      name: 'gold',
      type: 'congress',
      product_id: 'prod_LK8JHYVX3wpKVh',
      prices: {
        usd: {
          amount: fullPrices.gold.congress.usd,
          price_id: 'price_1KdU2ODHPIqaOssuieWFRJMw',
        },
        eur: {
          amount: fullPrices.gold.congress.eur,
          price_id: 'price_1KY5mUDHPIqaOssuBv4Bt93u',
        },
        cny: {
          amount: fullPrices.gold.congress.cny,
          price_id: 'price_1KnIGODHPIqaOssu1mExsoaO',
        },
      },
    },
    {
      name: 'gold',
      type: 'exhibition',
      product_id: 'prod_LK8JHYVX3wpKVh',
      prices: {
        usd: {
          amount: fullPrices.gold.exhibition.usd,
          price_id: 'price_1KdU2ODHPIqaOssuieWFRJMw',
        },
        eur: {
          amount: fullPrices.gold.exhibition.eur,
          price_id: 'price_1KY5n9DHPIqaOssup9P2m9oj',
        },
        cny: {
          amount: fullPrices.gold.exhibition.cny,
          price_id: 'price_1KnIFzDHPIqaOssulW2ap3J4',
        },
      },
    },
    /**
     * Using Gold Package prices for platinum until end of august 2022
     */
    {
      name: 'platinum',
      type: 'congress',
      product_id: 'prod_LK8JHYVX3wpKVh',
      prices: {
        usd: {
          amount: fullPrices.gold.congress.usd,
          price_id: 'price_1KdU2ODHPIqaOssuieWFRJMw',
        },
        eur: {
          amount: fullPrices.gold.congress.eur,
          price_id: 'price_1KY5nfDHPIqaOssuldfwozid',
        },
        cny: {
          amount: fullPrices.gold.congress.cny,
          price_id: 'price_1KnIHTDHPIqaOssuHUxycLY0',
        },
      },
    },
    {
      name: 'platinum',
      type: 'exhibition',
      product_id: 'prod_LK8JHYVX3wpKVh',
      prices: {
        usd: {
          amount: fullPrices.gold.exhibition.usd,
          price_id: 'price_1KdU2ODHPIqaOssuieWFRJMw',
        },
        eur: {
          amount: fullPrices.gold.exhibition.eur,
          price_id: 'price_1KY5oaDHPIqaOssuYYoLr7Ek',
        },
        cny: {
          amount: fullPrices.gold.exhibition.cny,
          price_id: 'price_1KnIH5DHPIqaOssu5zDdwpvM',
        },
      },
    },
  ],
};

const prices = {
  production: {
    venue: {
      exhibition: {
        gold: {
          usd: 'price_1KY5n9DHPIqaOssutUQ2yVqE',
          eur: 'price_1KY5n9DHPIqaOssup9P2m9oj',
          cny: 'price_1KnIFzDHPIqaOssulW2ap3J4',
        },
        platinum: {
          usd: 'price_1KY5oaDHPIqaOssudR9LIBL6',
          eur: 'price_1KY5oaDHPIqaOssuYYoLr7Ek',
          cny: 'price_1KnIH5DHPIqaOssu5zDdwpvM',
        },
      },
      congress: {
        gold: {
          usd: 'price_1KY5mUDHPIqaOssu4dmeuYvm',
          eur: 'price_1KY5mUDHPIqaOssuBv4Bt93u',
          cny: 'price_1KnIGODHPIqaOssu1mExsoaO',
        },
        platinum: {
          usd: 'price_1KY5nfDHPIqaOssuQKGvbgg8',
          eur: 'price_1KY5nfDHPIqaOssuldfwozid',
          cny: 'price_1LIZU2DHPIqaOssu6b7O6G85',
        },
      },
    },
  },
  development: {
    venue: {
      exhibition: {
        gold: {
          usd: 'price_1KdU2ODHPIqaOssuieWFRJMw',
          eur: 'price_1KdU2ODHPIqaOssukhgVRYA9',
          cny: 'price_1KdU2ODHPIqaOssukhgVRYA9',
        },
        platinum: {
          usd: 'price_1KdU2ODHPIqaOssuieWFRJMw',
          eur: 'price_1KdU2ODHPIqaOssukhgVRYA9',
          cny: 'price_1KdU2ODHPIqaOssukhgVRYA9',
        },
      },
      congress: {
        gold: {
          usd: 'price_1KdU2ODHPIqaOssuieWFRJMw',
          eur: 'price_1KdU2ODHPIqaOssukhgVRYA9',
          cny: 'price_1KdU2ODHPIqaOssukhgVRYA9',
        },
        platinum: {
          usd: 'price_1KdU2ODHPIqaOssuieWFRJMw',
          eur: 'price_1KdU2ODHPIqaOssukhgVRYA9',
          cny: 'price_1KdU2ODHPIqaOssukhgVRYA9',
        },
      },
    },
  },
};

export default prices;
